import React from 'react';
import { btnStyle } from '../PlateStyles';
import { formatirajDatumSRB } from '../PlateUtils';

const ImportDatModal = ({ dateRange, setDateRange, setSelectedFile, onImport, onClose, status }) => {
    const containerStyle = {
        position: 'relative',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#162447',
        border: '1px solid #3366ff',
        height: '40px',
        borderRadius: '4px',
        cursor: 'pointer'
    };

    const inputDateStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: 0, // Nevidljiv ali pokriva celu površinu
        cursor: 'pointer',
        zIndex: 2
    };

    return (
        <div style={{position: 'fixed', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.9)', display:'flex', justifyContent:'center', alignItems:'center', zIndex: 9999}}>
            <div style={{backgroundColor:'#0a132b', padding:'30px', borderRadius:'10px', width:'450px', border:'1px solid #1a2a4a'}}>
                <h3 style={{color: 'white', marginBottom: '20px'}}>Uvoz .DAT fajla</h3>
                <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} style={{width: '100%', marginBottom: '25px', color: 'white'}} />
                <div style={{display:'flex', gap:'15px', marginBottom:'25px'}}>
                    <div style={containerStyle}>
                        <input type="date" value={dateRange.od} onChange={(e) => setDateRange({...dateRange, od: e.target.value})} style={inputDateStyle} onClick={(e) => e.target.showPicker && e.target.showPicker()} />
                        <div style={{color: 'white', fontSize: '16px'}}>{formatirajDatumSRB(dateRange.od)}</div>
                    </div>
                    <div style={containerStyle}>
                        <input type="date" value={dateRange.do} onChange={(e) => setDateRange({...dateRange, do: e.target.value})} style={inputDateStyle} onClick={(e) => e.target.showPicker && e.target.showPicker()} />
                        <div style={{color: 'white', fontSize: '16px'}}>{formatirajDatumSRB(dateRange.do)}</div>
                    </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <button onClick={onImport} style={{...btnStyle, backgroundColor: '#28a745', color: 'white'}}>Učitaj</button>
                    <button onClick={onClose} style={{background: 'none', color: 'white', border: 'none', cursor: 'pointer', fontSize: '16px'}}>Zatvori</button>
                </div>
                <p style={{color: '#00ff00', marginTop: '15px', minHeight: '20px'}}>{status}</p>
            </div>
        </div>
    );
};
export default ImportDatModal;